import React, { useEffect } from "react";
import { PlanType, UtilityType } from "../../types/planType";
import { getPlansForCro } from "../../api/api";
import { injectIsFeaturedPlans } from "../../utils/injectIsFeaturedPlans";
import PlanCardSummaryMagicLink from "../../cro/PlanCardSummaryMagicLink";
import PlanCardSkeleton from "../../cro/PlanCardSkeleton";
import { useTranslation } from "react-i18next";
import { getEnrollmentRecord } from "../../api/enrollment";

const PlanSummaryCard = ({ selectedPlan, promocode }: any) => {
  const [cardLoading, setCardLoading] = React.useState(false);
  const [plan, setPlan] = React.useState<PlanType | null>(null);
  const [utility, setUtility] = React.useState<any>({});

  const url = new URL(window.location.href);
  const idParam = url.searchParams.get("id");
  const signParam = url.searchParams.get("sign");

  const utilityId = selectedPlan?.id_utility;
  const plan_id = selectedPlan?.id_plan;
  const utilityName = (utility as UtilityType)?.name || "";
  const isTx = (utility as UtilityType)?.markets?.state_code === "TX";
  const stateCode = (utility as UtilityType)?.markets?.state_code || "";

  const { i18n } = useTranslation();

  useEffect(() => {
    if (!utilityId) return;
    if (!signParam) {
      (async () => {
        setCardLoading(true);
        const response = await getPlansForCro({
          utility_id: utilityId,
          promocode,
          language: i18n.language || "en",
        });
        if (response.status === 200) {
          const injectIsFeatured = await injectIsFeaturedPlans(
            response.data?.plans as PlanType[],
            utilityId
          );
          const findCurrentPlan = injectIsFeatured.find(
            (plan: any) => "plan_id" in plan && plan.plan_id === String(plan_id)
          );
          if (findCurrentPlan) {
            setPlan(findCurrentPlan as PlanType);
          }
          setCardLoading(false);
          setUtility(response.data.utilities[utilityId] || {});
        } else {
          console.error("Error fetching plans:", response.statusText);
          setCardLoading(false);
        }
      })();
    } else {
      (async () => {
        const response = await getEnrollmentRecord(idParam, signParam);
        setPlan(
          (response?.data?.record.ef_product &&
            JSON.parse(response?.data?.record.ef_product)[0]) ||
            null
        );
      })();
    }
  }, [utilityId, promocode, plan_id, i18n.language, signParam, idParam]);

  if (cardLoading) return <PlanCardSkeleton />;

  if (!plan) return null;
  return (
    <PlanCardSummaryMagicLink
      isFeatured={plan?.isFeatured}
      utilityName={utilityName}
      utilityId={utilityId}
      plan={plan}
      isTypeVariable={
        stateCode === "PA" && plan.plan_name.includes("Embrace Green 3")
      }
      isTx={isTx || true} // fallback to true because magic link is always tx
    />
  );
};

export default PlanSummaryCard;
